// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/styles/Dashboard.css - UPDATED WITH LIGHT THEME */

.dashboard-container {
  min-height: calc(100vh - var(--navbar-height));
  padding: 4rem 2rem 4rem;
  padding-top: var(--navbar-height);
  background: var(--gradient-hero); /* Light theme gradient background */
}

.dashboard-header {
  text-align: center;
  margin-bottom: 3rem;
  max-width: 900px;
  margin-left: auto;
  margin-right: auto;
}

.dashboard-header h1 {
  font-size: 2.5rem;
  color: var(--text-primary); /* Dark text */
  margin-bottom: 1rem;
  font-weight: 600;
  line-height: 1.2;
}

.dashboard-subtitle {
  font-size: 1.2rem;
  color: var(--text-secondary); /* Medium gray text */
  line-height: 1.4;
  max-width: 600px;
  margin: 0 auto;
}

/* Stat Cards (Used on Dashboard, but let's keep consistent styling) */
.dashboard-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  margin-bottom: 3rem;
  max-width: 900px;
  margin-left: auto;
  margin-right: auto;
}

.stat-card {
  background: var(--bg-primary); /* White */
  border: 1px solid var(--border-primary); /* Light gray border */
  border-radius: var(--border-radius-xl);
  padding: 1.8rem;
  text-align: center;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  min-height: 140px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.stat-card:hover {
  transform: translateY(-5px);
  border-color: var(--text-accent); /* Red border */
  box-shadow: var(--shadow-lg);
}

.stat-card h3 {
  color: var(--text-primary); /* Dark text */
  font-size: 1rem;
  margin-bottom: 1rem;
  font-weight: 500;
}

.stat-card-split {
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 100%;
}

.stat-item {
  flex: 1 1;
  text-align: center;
  position: relative;
}

.stat-item:first-child::after {
  content: '';
  position: absolute;
  right: 0;
  top: 10%;
  height: 80%;
  width: 1px;
  background-color: var(--border-primary); /* Light gray separator */
}

.stat-number {
  font-size: 2.2rem;
  color: var(--text-accent); /* Red number */
  font-weight: 700;
  margin-bottom: 0.5rem;
  line-height: 1;
}

.stat-status { /* For plan name */
  font-size: 1.3rem;
  color: var(--text-primary); /* Dark text */
  font-weight: 600;
  margin-bottom: 0.5rem;
  line-height: 1;
}

.stat-date { /* For member since */
  font-size: 1.1rem;
  color: var(--text-secondary); /* Medium gray text */
  font-weight: 500;
  margin-bottom: 0.5rem;
  line-height: 1;
}

.stat-description {
  font-size: 0.85rem;
  color: var(--text-secondary); /* Medium gray text */
  line-height: 1.3;
}

/* Action Cards (Used on Dashboard) */
.dashboard-actions {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  max-width: 1000px;
  margin: 0 auto;
}

.action-card {
  background: var(--bg-primary); /* White */
  border: 1px solid var(--border-primary); /* Light gray border */
  border-radius: 18px;
  padding: 2rem;
  text-align: center;
  transition: all 0.4s ease;
  min-height: 220px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.action-card:hover {
  transform: translateY(-5px);
  box-shadow: var(--shadow-xl);
  border-color: var(--text-accent); /* Red border */
}

.action-card h2 {
  color: var(--text-primary); /* Dark text */
  font-size: 1.5rem;
  margin-bottom: 1rem;
  font-weight: 600;
}

.action-card p {
  color: var(--text-secondary); /* Medium gray text */
  margin-bottom: 1.5rem;
  line-height: 1.5;
  font-size: 0.95rem;
}

/* Action Buttons (Keep using light theme styles) */
.action-button {
  display: inline-block;
  background: var(--gradient-button); /* Red gradient */
  color: var(--text-on-gradient); /* White text */
  padding: 1rem 2.5rem;
  border-radius: var(--border-radius-full);
  text-decoration: none;
  font-size: 1rem;
  font-weight: 600;
  transition: all 0.3s ease;
  margin-top: auto; /* Pushes button to bottom in flex container */
}

.action-button:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-button-hover);
}

.action-button.secondary {
  background: transparent;
  border: 1px solid var(--border-primary); /* Light gray border */
  color: var(--text-primary); /* Dark text */
  box-shadow: none;
}

.action-button.secondary:hover {
  background: var(--bg-secondary); /* Very light gray background */
  border-color: var(--text-secondary); /* Medium gray border */
  color: var(--text-primary);
  box-shadow: var(--shadow-lg);
  transform: translateY(-2px);
}`, "",{"version":3,"sources":["webpack://./src/styles/Dashboard.css"],"names":[],"mappings":"AAAA,wDAAwD;;AAExD;EACE,8CAA8C;EAC9C,uBAAuB;EACvB,iCAAiC;EACjC,gCAAgC,EAAE,oCAAoC;AACxE;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,0BAA0B,EAAE,cAAc;EAC1C,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,4BAA4B,EAAE,qBAAqB;EACnD,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,sEAAsE;AACtE;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B,EAAE,UAAU;EACzC,uCAAuC,EAAE,sBAAsB;EAC/D,sCAAsC;EACtC,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,gCAAgC,EAAE,eAAe;EACjD,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B,EAAE,cAAc;EAC1C,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,WAAW;EACX,UAAU;EACV,uCAAuC,EAAE,yBAAyB;AACpE;;AAEA;EACE,iBAAiB;EACjB,yBAAyB,EAAE,eAAe;EAC1C,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,eAAe,kBAAkB;EAC/B,iBAAiB;EACjB,0BAA0B,EAAE,cAAc;EAC1C,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,aAAa,qBAAqB;EAChC,iBAAiB;EACjB,4BAA4B,EAAE,qBAAqB;EACnD,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B,EAAE,qBAAqB;EACnD,gBAAgB;AAClB;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,6BAA6B,EAAE,UAAU;EACzC,uCAAuC,EAAE,sBAAsB;EAC/D,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,gCAAgC,EAAE,eAAe;AACnD;;AAEA;EACE,0BAA0B,EAAE,cAAc;EAC1C,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B,EAAE,qBAAqB;EACnD,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,mDAAmD;AACnD;EACE,qBAAqB;EACrB,kCAAkC,EAAE,iBAAiB;EACrD,8BAA8B,EAAE,eAAe;EAC/C,oBAAoB;EACpB,wCAAwC;EACxC,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB,EAAE,8CAA8C;AAClE;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,uBAAuB;EACvB,uCAAuC,EAAE,sBAAsB;EAC/D,0BAA0B,EAAE,cAAc;EAC1C,gBAAgB;AAClB;;AAEA;EACE,+BAA+B,EAAE,+BAA+B;EAChE,mCAAmC,EAAE,uBAAuB;EAC5D,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;AAC7B","sourcesContent":["/* src/styles/Dashboard.css - UPDATED WITH LIGHT THEME */\n\n.dashboard-container {\n  min-height: calc(100vh - var(--navbar-height));\n  padding: 4rem 2rem 4rem;\n  padding-top: var(--navbar-height);\n  background: var(--gradient-hero); /* Light theme gradient background */\n}\n\n.dashboard-header {\n  text-align: center;\n  margin-bottom: 3rem;\n  max-width: 900px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.dashboard-header h1 {\n  font-size: 2.5rem;\n  color: var(--text-primary); /* Dark text */\n  margin-bottom: 1rem;\n  font-weight: 600;\n  line-height: 1.2;\n}\n\n.dashboard-subtitle {\n  font-size: 1.2rem;\n  color: var(--text-secondary); /* Medium gray text */\n  line-height: 1.4;\n  max-width: 600px;\n  margin: 0 auto;\n}\n\n/* Stat Cards (Used on Dashboard, but let's keep consistent styling) */\n.dashboard-stats {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 2rem;\n  margin-bottom: 3rem;\n  max-width: 900px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.stat-card {\n  background: var(--bg-primary); /* White */\n  border: 1px solid var(--border-primary); /* Light gray border */\n  border-radius: var(--border-radius-xl);\n  padding: 1.8rem;\n  text-align: center;\n  transition: all 0.3s ease;\n  position: relative;\n  overflow: hidden;\n  min-height: 140px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.stat-card:hover {\n  transform: translateY(-5px);\n  border-color: var(--text-accent); /* Red border */\n  box-shadow: var(--shadow-lg);\n}\n\n.stat-card h3 {\n  color: var(--text-primary); /* Dark text */\n  font-size: 1rem;\n  margin-bottom: 1rem;\n  font-weight: 500;\n}\n\n.stat-card-split {\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  width: 100%;\n}\n\n.stat-item {\n  flex: 1;\n  text-align: center;\n  position: relative;\n}\n\n.stat-item:first-child::after {\n  content: '';\n  position: absolute;\n  right: 0;\n  top: 10%;\n  height: 80%;\n  width: 1px;\n  background-color: var(--border-primary); /* Light gray separator */\n}\n\n.stat-number {\n  font-size: 2.2rem;\n  color: var(--text-accent); /* Red number */\n  font-weight: 700;\n  margin-bottom: 0.5rem;\n  line-height: 1;\n}\n\n.stat-status { /* For plan name */\n  font-size: 1.3rem;\n  color: var(--text-primary); /* Dark text */\n  font-weight: 600;\n  margin-bottom: 0.5rem;\n  line-height: 1;\n}\n\n.stat-date { /* For member since */\n  font-size: 1.1rem;\n  color: var(--text-secondary); /* Medium gray text */\n  font-weight: 500;\n  margin-bottom: 0.5rem;\n  line-height: 1;\n}\n\n.stat-description {\n  font-size: 0.85rem;\n  color: var(--text-secondary); /* Medium gray text */\n  line-height: 1.3;\n}\n\n/* Action Cards (Used on Dashboard) */\n.dashboard-actions {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 2rem;\n  max-width: 1000px;\n  margin: 0 auto;\n}\n\n.action-card {\n  background: var(--bg-primary); /* White */\n  border: 1px solid var(--border-primary); /* Light gray border */\n  border-radius: 18px;\n  padding: 2rem;\n  text-align: center;\n  transition: all 0.4s ease;\n  min-height: 220px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.action-card:hover {\n  transform: translateY(-5px);\n  box-shadow: var(--shadow-xl);\n  border-color: var(--text-accent); /* Red border */\n}\n\n.action-card h2 {\n  color: var(--text-primary); /* Dark text */\n  font-size: 1.5rem;\n  margin-bottom: 1rem;\n  font-weight: 600;\n}\n\n.action-card p {\n  color: var(--text-secondary); /* Medium gray text */\n  margin-bottom: 1.5rem;\n  line-height: 1.5;\n  font-size: 0.95rem;\n}\n\n/* Action Buttons (Keep using light theme styles) */\n.action-button {\n  display: inline-block;\n  background: var(--gradient-button); /* Red gradient */\n  color: var(--text-on-gradient); /* White text */\n  padding: 1rem 2.5rem;\n  border-radius: var(--border-radius-full);\n  text-decoration: none;\n  font-size: 1rem;\n  font-weight: 600;\n  transition: all 0.3s ease;\n  margin-top: auto; /* Pushes button to bottom in flex container */\n}\n\n.action-button:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-button-hover);\n}\n\n.action-button.secondary {\n  background: transparent;\n  border: 1px solid var(--border-primary); /* Light gray border */\n  color: var(--text-primary); /* Dark text */\n  box-shadow: none;\n}\n\n.action-button.secondary:hover {\n  background: var(--bg-secondary); /* Very light gray background */\n  border-color: var(--text-secondary); /* Medium gray border */\n  color: var(--text-primary);\n  box-shadow: var(--shadow-lg);\n  transform: translateY(-2px);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
